import formatDate from '@/utils/helpers/format-date';
import { getToday } from '@/utils/helpers/get-formatted-date-for-api';

const zurichFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: 'Europe/Zurich',
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
});

const isSameDayAsToday = (dateInput?: Date | string | null) => {
  if (!dateInput) {
    return false;
  }

  if (typeof dateInput === 'string') {
    const todayString = formatDate(getToday());

    return dateInput === todayString;
  }

  if (isNaN(dateInput.getTime())) {
    return false;
  }

  const dateInZurich = zurichFormatter.format(dateInput);
  const todayInZurich = zurichFormatter.format(new Date());

  return dateInZurich === todayInZurich;
};

export default isSameDayAsToday;
